import { useSyncExternalStore } from "react";

/** The project a multi-project customer opened, shared by the listing views. */
export interface ProjectSelection {
  readonly selected: () => string | undefined;
  readonly select: (project: string | undefined) => void;
  readonly subscribe: (listener: () => void) => () => void;
}

export function createProjectSelection(): ProjectSelection {
  let selectedProject: string | undefined;
  const listeners = new Set<() => void>();
  return {
    selected: () => selectedProject,
    select: (project) => {
      selectedProject = project;
      listeners.forEach((listener) => {
        listener();
      });
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}

const NO_SUBSCRIPTION = (): (() => void) => () => undefined;
const NOTHING_SELECTED = (): undefined => undefined;

/** Re-render on every change to the selection; without one, nothing is ever selected. */
export function useSelectedProject(
  projectSelection: ProjectSelection | undefined,
): string | undefined {
  return useSyncExternalStore(
    projectSelection?.subscribe ?? NO_SUBSCRIPTION,
    projectSelection?.selected ?? NOTHING_SELECTED,
  );
}
